declare global {
	interface Window {
		gtag: (...args: unknown[]) => void;
		dataLayer: Record<string, unknown>[];
	}
}

const isInternalTraffic = () =>
	typeof localStorage !== "undefined" &&
	localStorage.getItem("notrack") === "1";

export function trackEvent(
	eventName: string,
	params?: Record<string, unknown>,
) {
	if (typeof window === "undefined" || isInternalTraffic()) return;
	if (typeof window.gtag === "function") {
		window.gtag("event", eventName, params);
	} else {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ event: eventName, ...params });
	}
}
